import type { EasySearchHitDto } from '@dhl/mdp-api'
import { findPropertyRecursively } from '../helpers'

export const useBlobPaths = (hits: EasySearchHitDto[]) => {
  /**
   * All unique blob paths from the hits' payload
   */
  const paths = Array.from(
    new Set(
      hits.flatMap((hit) => {
        try {
          const payload: unknown = hit.payload ? JSON.parse(hit.payload) : {}
          return findPropertyRecursively(payload, 'blob_path')
        } catch (_error) {
          return []
        }
      })
    )
  )

  const blobPaths = paths.map((path) => ({
    blobPath: path,
    fileName: path.split('/').pop() || 'unknown',
  }))

  const hasBlobPaths = paths.length > 0

  return { hasBlobPaths, blobPaths }
}
